/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface SurveyZeroNoteSiblingDto
 */
export interface SurveyZeroNoteSiblingDto {
    /**
     * 
     * @type {string}
     * @memberof SurveyZeroNoteSiblingDto
     */
    'birthDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SurveyZeroNoteSiblingDto
     */
    'healthy'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SurveyZeroNoteSiblingDto
     */
    'healthyDescription'?: string;
    /**
     * 
     * @type {number}
     * @memberof SurveyZeroNoteSiblingDto
     */
    'id'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SurveyZeroNoteSiblingDto
     */
    'sameParents'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SurveyZeroNoteSiblingDto
     */
    'sameParentsDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyZeroNoteSiblingDto
     */
    'sex'?: SurveyZeroNoteSiblingDtoSexEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum SurveyZeroNoteSiblingDtoSexEnum {
    Male = 'MALE',
    Female = 'FEMALE'
}


